/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

const controller = "/resolvedAlerts";
const resolvedAlertsService = {
    getAllResolvedAlerts: async () => {
        const response = await http.get(`${controller}/getAllResolvedAlerts`);
        return response.data;
    },

    getResolveActionByType: async (alertTypeId) => {
        const response = await http.get(`${controller}/getResolveActionByType?alertTypeId=${alertTypeId}`);
        return response.data;
    },

    updateResolvedAlert: async (resolvedAlert) => {
        const response = await http.post(`${controller}/updateResolvedAlert`, resolvedAlert);
        return response.data;
    }
}

export default resolvedAlertsService;